'use client';

import type {TagProps} from '@chakra-ui/react';
import {Tag as BaseTag, resolveStyleConfig, useColorMode} from '@chakra-ui/react';
import {useTheme} from '@emotion/react';
import type {FC} from 'react';
import {forwardRef} from 'react';

import {tagTheme} from './theme';

type Props = {} & TagProps;

/** Tag component is used for items that need to be labeled, categorized, or organized using keywords that describe them. */
export const Tag: FC<Props> = props => {
  return <BaseTag {...props} />;
};

export type {Props as TagProps};

/**
 * An updated version of the Tag component that uses the new theme system.
 */
const NextTag = forwardRef<HTMLSpanElement, TagProps>((props, ref) => {
  const theme = useTheme();
  const mode = useColorMode();
  const style = resolveStyleConfig(tagTheme)({
    theme,
    colorMode: mode,
    ...props,
  });

  return <BaseTag data-scheme={props.colorScheme} sx={style} ref={ref} {...props} />;
});

export {NextTag};
